import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphaSpaceOnlyInput]',
  standalone: true,
})
export class AlphaSpaceOnlyInputDirective {
  private readonly ngControl = inject(NgControl, { optional: true });

  private processValue(value: string, input: HTMLInputElement): string {
    let filteredValue = value.replaceAll(/[^a-zA-Z ]/g, '').replace(/^\s+/, '');

    // Respect maxlength attribute
    const maxLength = input.getAttribute('maxlength');
    if (maxLength !== null) {
      filteredValue = filteredValue.slice(0, Number.parseInt(maxLength, 10));
    }

    return filteredValue;
  }

  private setValue(input: HTMLInputElement, value: string, emitEvent = true): void {
    if (this.ngControl) {
      this.ngControl.control?.setValue(value, { emitEvent });
    } else {
      input.value = value;
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const processedValue = this.processValue(input.value, input);
    // Only update if value changed to avoid infinite loops
    if (this.ngControl?.control?.value !== processedValue) {
      this.setValue(input, processedValue, false);
      // Trigger validation manually for input events (this emits status changes)
      this.ngControl?.control?.updateValueAndValidity();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const pastedText = event.clipboardData?.getData('text') || '';
    const filteredValue = this.processValue(pastedText, input);

    const currentValue = input.value || '';
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;
    const finalValue = this.processValue(
      currentValue.slice(0, start) + filteredValue + currentValue.slice(end),
      input
    );

    // Emit events for paste so validation runs
    this.setValue(input, finalValue, true);

    // Set cursor position after the pasted content
    setTimeout(() => {
      const cursorPos = Math.min(start + filteredValue.length, finalValue.length);
      input.setSelectionRange(cursorPos, cursorPos);
    }, 0);
  }
}
